import React from 'react'

const Arrow = (props) => (
  <svg width={17} height={16} {...props}>
    <path
      d="M9.366 12.692l5.775-5.775a.969.969 0 111.37 1.37l-7.428 7.43a.969.969 0 01-1.37 0l-7.43-7.43a.969.969 0 011.371-1.37l5.775 5.775V1.013c0-.56.433-1.013.969-1.013.535 0 .968.454.968 1.013v11.679z"
      fillRule="nonzero"
    />
  </svg>
)

export default Arrow
